<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="dealerRef" :options="item.options" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Dealerachievementratetable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Dealerachievementratetable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Dealerachievementratetable from './components/dealerachievementratetable.vue'
	import utils from '../../../common/utils'
	import {
		BAReportProcessList,
		BAReportExportProcessList,
		ASNVoucherType,
		InventoryClassList,
		GetProvince
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Dealerachievementratetable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: []
					},
					{
						inputdata: '',
						title: '业务员',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: '',
						inputtype: 'input',
						width: '230px'
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: []
					},
					{
						inputdata: '',
						title: '医院名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '230px'
					},
				],
				from: {
					InvClass: "",
					TrueName: "",
					HPName: "",
					ProvinceID: "",
				}
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			this.getProvince()
			// this.BAReportProcessList()
			this.inventoryClassList()
		},
		methods: {
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				if (code == 0) {
					this.formdata[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[2].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data,
					message
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[0].options.push(obj)
					})
					this.formdata[0].inputdata = this.formdata[0].options[0].key
					//this.BAReportProcessList()
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			// 列表
			async BAReportProcessList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code,
					message
				} = await BAReportProcessList({
					InvClass: this.from.InvClass == '' ? this.formdata[0].inputdata : this.from.InvClass,
					TrueName: this.from.TrueName,
					HPName: this.from.HPName,
					ProvinceID: this.from.ProvinceID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
				loading.close();
			},
			// 导出
			async BAReportExportProcessList() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await BAReportExportProcessList({
					InvClass: this.from.InvClass,
					TrueName: this.from.TrueName,
					HPName: this.from.HPName,
					ProvinceID: this.from.ProvinceID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `入院进度报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.BAReportExportProcessList()
			},

			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.BAReportProcessList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.BAReportProcessList()
			},
			select() {
				this.pageindex = 1
				try {
					this.from.InvClass = this.$refs.dealerRef[0].modelvalue
					this.from.TrueName = this.$refs.dealerRef[1].modelvalue
					this.from.ProvinceID = this.$refs.dealerRef[2].modelvalue
					this.from.HPName = this.$refs.dealerRef[3].modelvalue
					this.BAReportProcessList()
				} catch (error) {
					this.BAReportProcessList()
				}
			},
			reset() {
				this.$refs.dealerRef.map((item, index) => {
					item.modelvalue = ""
				})
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 5px;
		padding-bottom: 60px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		//   margin-top: 4px;
		margin-right: 20px;
	}
</style>
